import { ParsingError } from './parsing-error';

/** Ошибка аргумента указывающего на несуществующий параметр */
export class ArgumentPointerError extends ParsingError {
    constructor(argument: string) {
        super(`argument "${argument}" points to a non-existent param`);
        this.name = 'ArgumentPointerError';
    }
}
